var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_n_4139_526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.334 16.6665H34.0007L19.0007 38.3332V23.3332H7.33398L22.334 1.6665V16.6665Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4139_526",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 1,
    width: 28,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.334 16.6665H34.0007L19.0007 38.3332V23.3332H7.33398L22.334 1.6665V16.6665Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4139_526)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_fn_4139_526)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1519,
    cy: 32.9743,
    rx: 17.1642,
    ry: 30.7569,
    transform: "rotate(-101.867 20.1519 32.9743)",
    fill: "url(#paint0_linear_4139_526)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_fn_4139_526)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.7712,
    cy: -9.92962,
    rx: 24.3611,
    ry: 39.1926,
    transform: "rotate(-99.7597 7.7712 -9.92962)",
    fill: "#FF5E00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_n_4139_526",
    x: 7.33398,
    y: 1.6665,
    width: 26.667,
    height: 36.6665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_4139_526"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_fn_4139_526",
    x: -22.6572,
    y: 2.521,
    width: 85.6182,
    height: 60.9067,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25,
    result: "effect1_foregroundBlur_4139_526"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_foregroundBlur_4139_526",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_4139_526"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_foregroundBlur_4139_526"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_fn_4139_526",
    x: -43.5771,
    y: -47.3467,
    width: 102.697,
    height: 74.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25,
    result: "effect1_foregroundBlur_4139_526"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "1.6000000238418579 1.6000000238418579",
    stitchTiles: "stitch",
    numOctaves: 3,
    result: "noise",
    seed: 5142
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "effect1_foregroundBlur_4139_526",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(0, 0, 0, 0.25)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_4139_526"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "effect1_foregroundBlur_4139_526"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4139_526",
    x1: 41.4853,
    y1: 24.9383,
    x2: 19.2881,
    y2: 38.7512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.276417,
    stopColor: "#081681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.583149,
    stopColor: "#0F9CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#997BAF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseIcon6);
export default __webpack_public_path__ + "static/media/caseIcon6.3c680aef7138c09edc9b9d99fd9969a2.svg";
export { ForwardRef as ReactComponent };